import { combineReducers } from 'redux-immutable'

import data from './data'
import dialogs from './dialogs'

export default combineReducers({
  data,
  dialogs
})
